export enum ProjectEventTypeTaskAction {
  BasicForm,
}
